export default "__VITE_ASSET__mC2pVPiS__"